/** @format */

import { skipToken } from "@reduxjs/toolkit/dist/query";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useSearchParams, Navigate } from "react-router-dom";
import ErrorPage from "../../features/errorPage/ErrorPage";
import { useHwbLoginQuery } from "../authApi";
import { getHwbAuthLink, HWB_AUTH_STATE_VALUE } from "./hwbService";

export const HwbLogin: React.FC = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");

  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);

  // code not in params, so redirect and get hwb to put it into params.
  if (code === null) window.location.href = getHwbAuthLink();

  const { isSuccess, error } = useHwbLoginQuery(
    code === null || searchParams.get("state") !== HWB_AUTH_STATE_VALUE
      ? skipToken
      : {
          code: code,
          origin: encodeURIComponent(
            `${window.location.origin}/en/auth/hwblogin`,
          ),
        },
  );

  useEffect(() => {
    // set in useEffect to avoid navigating away before state is updated
    if (isSuccess) setIsLoggedIn(true);
  }, [isSuccess]);

  if (error !== undefined) {
    return (
      <ErrorPage
        statusCode={500}
        actions={["report"]}
        hiddenMessage={`failed hwb login. ${JSON.stringify(error)}`}
      />
    );
  }

  if (!isLoggedIn) {
    return (
      <div className="position-absolute top-50 start-50 translate-middle">
        <Spinner />
      </div>
    );
  } else {
    return <Navigate to="/" />;
  }
};
